import { Typography, Box, Divider, Chip, Tooltip } from "@mui/material";
import {
  PhoneInTalk,
  Fax,
  Mail,
  WhatsApp,
  Web,
  Instagram,
  YouTube,
  LinkedIn,
  LocalGroceryStore,
  Email,
} from "@mui/icons-material";
import Grid from "@mui/material/Unstable_Grid2";
import logo from "../../assetes/logo.png";
import "./contact.css";

import { useTheme } from "@mui/material/styles";
const ContactUs = () => {
  const theme = useTheme();
  return (
    <>
      <div id="contact">
        <Divider
          textAlign="center"
          sx={{
            mt: 7,
            "&::before,&::after": {
              borderColor: "primary",
            },
          }}
        >
          <Chip
            sx={{ p: 3 }}
            label={
              <Typography variant="h2" sx={{ fontSize: "2rem", margin: 2 }}>
                ارتباط با ما
              </Typography>
            }
          ></Chip>
        </Divider>
        <Box variant="div">
          <Grid container>
            <Grid sm={12}>
              <Box>
                <img src={logo} className="footer-logo" alt="لوگو ایما"></img>
                <Typography
                  className="text-logo-footer"
                  variant="body1"
                  sx={{
                    fontFamily: "Homa",
                    color: "#49519A",
                  }}
                >
                  گروه صنعتی ایما
                </Typography>
              </Box>
            </Grid>
            <Grid sm={6}>
              <Box variant="div" className="address">
                <Typography className="text-add">آدرس دفتر تهران:</Typography>
                <Typography className="text-add">
                  تهران ، سعادت آباد ، خیابان سرو ، میدان فرهنگ ، پیوند دوم ،
                  پلاک 57
                </Typography>
                <Box className="text-tel">
                  <Typography className="th-logo">
                    021-22351332
                    <PhoneInTalk
                      sx={{ color: "#49519A", margin: 1, fontSize: "30px" }}
                    />
                  </Typography>
                  <Typography className="th-logo">
                    09128891585
                    <WhatsApp
                      sx={{ color: "#49519A", margin: 1, fontSize: "30px" }}
                    />
                  </Typography>
                </Box>
              </Box>
            </Grid>
            <Grid sm={6}>
              <Box variant="div" className="address">
                <Typography className="text-add">آدرس دفتر تبریز:</Typography>
                <Typography className="text-add">
                  {" "}
                  تبریز ، خیابان شریعتی جنوبی ، ابتدای پاستور جدید ، ساختمان مهر{" "}
                </Typography>
                <Box className="text-tel">
                  <Typography className="tb-logo">
                    041-35553378
                    <PhoneInTalk
                      sx={{ color: "#49519A", margin: 1, fontSize: "30px" }}
                    />
                  </Typography>
                  <Typography className="tb-logo">
                    09146585671
                    <WhatsApp
                      sx={{ color: "#49519A", margin: 1, fontSize: "30px" }}
                    />
                  </Typography>
                  <Typography className="tb-logo">
                    041-35570065
                    <Fax
                      sx={{ color: "#49519A", margin: 1, fontSize: "30px" }}
                    />
                  </Typography>
                </Box>
              </Box>
            </Grid>
            <Grid sm={6}>
              <Box variant="div" className="address">
                <Typography className="text-add">آدرس دفتر خوزستان:</Typography>
                <Typography className="text-add">
                  دزفول ، بلوار چهل و پنج متری مقاومت ، جنب پارک نارنج ، پلاک
                  287
                </Typography>
                <Box className="text-tel">
                  <Typography className="tb-logo">
                    09032991424
                    <PhoneInTalk
                      sx={{ color: "#49519A", margin: 1, fontSize: "30px" }}
                    />
                  </Typography>
                </Box>
              </Box>
            </Grid>
            <Grid sm={6}>
              <Box variant="div" className="address">
                <Typography className="text-add">آدرس دفتر اصفهان:</Typography>
                <Typography className="text-add">
                  اصفهان ، خیابان مشتاق اول ، کوچه باغ برج ، پلاک 15
                </Typography>
                <Box className="text-tel">
                  <Typography className="tb-logo">
                    09137972751
                    <PhoneInTalk
                      sx={{ color: "#49519A", margin: 1, fontSize: "30px" }}
                    />
                  </Typography>
                </Box>
              </Box>
            </Grid>

            <Grid
              sm={12}
              sx={{ display: "flex", justifyContent: "center", m: 2 }}
            >
              <Box variant="div" className="social-media">
                <Tooltip title="Instagram " sx={{ fontFamily: "roboto" }}>
                  <a
                    target="_blank"
                    href="https://www.instagram.com/imaindco?igsh=aXdyM21uNTJ3YjEy"
                  >
                    <Instagram
                      sx={{ color: "#49519A", margin: 1, fontSize: "44px" }}
                    />
                  </a>
                </Tooltip>
                <Tooltip title="Youtube " sx={{ fontFamily: "roboto" }}>
                  <a target="_blank" href="https://www.youtube.com/@IMAINDco">
                    <YouTube
                      sx={{ color: "#49519A", margin: 1, fontSize: "45px" }}
                    />
                  </a>
                </Tooltip>
                <Tooltip title="linkedin " sx={{ fontFamily: "roboto" }}>
                  <a
                    target="_blank"
                    href="https://www.linkedin.com/in/ima-ind-co-b50b06127"
                  >
                    <LinkedIn
                      sx={{ color: "#49519A", margin: 1, fontSize: "45px" }}
                    />
                  </a>
                </Tooltip>
                <Tooltip title="Email " sx={{ fontFamily: "roboto" }}>
                  <a
                    target="_blank"
                    href="mailto:info@gmail.com

"
                  >
                    <Email
                      sx={{ color: "#49519A", margin: 1, fontSize: "45px" }}
                    />
                  </a>
                </Tooltip>
              </Box>
            </Grid>
            <Typography sx={{ textAlign: "center" }}>
              کلیه حقوق این وبسایت متعلق به گروه صنعتی ایما می باشد.
            </Typography>
          </Grid>
        </Box>
      </div>
    </>
  );
};

export default ContactUs;
